import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon_panel_profile.svg'
import _imports_1 from '@/assets/img/icon_panel_career.svg'
import _imports_2 from '@/assets/img/icon_panel_decline.svg'
import _imports_3 from '@/assets/img/icon_panel_home.svg'
import _imports_4 from '@/assets/img/icon_panel_search.svg'
import _imports_5 from '@/assets/img/icon_panel_recommend.svg'
import _imports_6 from '@/assets/img/icon_panel_pending.svg'
import _imports_7 from '@/assets/img/icon_panel_active.svg'
import _imports_8 from '@/assets/img/icon_panel_logout.svg'


const _withScopeId = n => (_pushScopeId("data-v-29cacf4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_menu_user_name" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header_menu_user_suffix" }, "様", -1))
const _hoisted_3 = {
  key: 0,
  class: "panel"
}
const _hoisted_4 = { class: "panel_inner" }
const _hoisted_5 = { class: "panel_layout" }
const _hoisted_6 = { class: "panel_user_name" }
const _hoisted_7 = { class: "panel_user_name_label" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_user_name_suffix" }, "様", -1))
const _hoisted_9 = { class: "panel_user_mail" }
const _hoisted_10 = { class: "panel_layout" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panel_item_icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label" }, "基本情報", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panel_item_icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label" }, "キャリアシート", -1))
const _hoisted_16 = {
  key: 0,
  class: "panel_item_badge"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panel_item_icon",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label" }, "辞退した求人", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "panel_layout panel_sp_disp" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panel_item_icon",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label" }, "ホーム", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panel_item_icon",
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label" }, "求人検索", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panel_item_icon",
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label" }, "おすすめの求人", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panel_item_icon",
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label" }, "検討中の求人", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panel_item_icon",
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label" }, "応募中の求人", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "panel_layout" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label_provision" }, "利用規約への同意", -1))
const _hoisted_38 = {
  key: 0,
  class: "panel_item_badge"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel_inquiry" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "panel_inquiry_label" }, "お問い合わせ"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "panel_inquiry_mail text_link",
    href: "mailto:webmaster@massmedian.co.jp"
  }, "webmaster@massmedian.co.jp")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panel_item_icon",
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_item_label_logout" }, "ログアウト", -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]

import { ref, computed } from 'vue';
import store from '@/store';
import { useRouter } from 'vue-router';
import { postAuthLogout } from '@/api/accountEndpoint';
import { getMailAddress } from '@/api/careersheetEndpoint';
import cookies from 'vue-cookies';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  setup(__props) {

const init = async () => {
  try {
    const [resMailAddress] = await Promise.all([getMailAddress(), store.dispatch('userMenu/receive')]);
    mailAddress.value = resMailAddress.emailAddress;
  } catch (error) {
    console.error(error);
  }
};
init();

const mailAddress = ref('');

const menu = computed(() => {
  return store.getters['userMenu/userMenu'];
});
const displayContents = computed(() => {
  return menu.value.displayContents;
});
const careersheetNonInputStatus = computed(() => {
  return menu.value.careersheetNonInputStatus;
});
const isSearchLockUser = computed(() => {
  return store.getters['userMenu/isSearchLockUser'];
});
const links = {
  1: { name: 'c00' },
  2: { name: 'c01' },
  3: { name: 'c02' },
  4: { name: 'c03' },
  6: { name: 'c07' },
  7: { name: 'c08' },
  8: { name: 'c09' },
  9: { name: 'c10' },
  10: { name: 'c11' },
  11: { name: 'c12' },
  12: { name: 'c14' },
} as Record<number, { name: string }>;

const router = useRouter();
const isMenuOpen = ref(false);
const transitionPage = (name: string) => {
  router.push({ name: name });
  closeMenu();
};
const transitionCareerSheetPage = () => {
  // C系未完了状態の時はC系に遷移する
  if (displayContents.value === 1) {
    const status = careersheetNonInputStatus.value || 0;
    const link = links[status];
    router.push({ name: link.name });
  } else {
    router.push({ name: 'n30' });
  }
  closeMenu();
};
const openMenu = () => {
  isMenuOpen.value = true;
};
const closeMenu = () => {
  isMenuOpen.value = false;
};
const logout = async () => {
  try {
    await postAuthLogout();
    store.dispatch('toasts/appendTimeToast', { label: 'ログアウトしました' });
    store.commit('router/initLoginTransitionData');
    router.push({ name: 'a10' });

    // cookieに格納してある求職者IDを削除
    cookies.remove('userId01_c');


  } catch (error) {
    console.error(error);
  }
};

window.addEventListener('popstate', function () {
  closeMenu();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: openMenu,
      class: "header_menu"
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(menu).lastname) + _toDisplayString(_unref(menu).firstname), 1),
      _hoisted_2
    ]),
    (isMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: closeMenu,
          class: "panel_bg"
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (isMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(menu).lastname) + _toDisplayString(_unref(menu).firstname), 1),
                    _hoisted_8
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(mailAddress.value), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (transitionPage('n20'))),
                    class: "panel_item"
                  }, _hoisted_13),
                  _createElementVNode("div", {
                    onClick: transitionCareerSheetPage,
                    class: "panel_item"
                  }, [
                    _hoisted_14,
                    _hoisted_15,
                    (_unref(displayContents) === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "未入力"))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(displayContents) === 6)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (transitionPage('m00'))),
                        class: "panel_item"
                      }, _hoisted_19))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (transitionPage('f00'))),
                    class: "panel_item"
                  }, _hoisted_23),
                  (_unref(displayContents) === 6)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!_unref(isSearchLockUser))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (transitionPage('h00'))),
                              class: "panel_item"
                            }, _hoisted_26))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (transitionPage('l00'))),
                          class: "panel_item"
                        }, _hoisted_29),
                        _createElementVNode("div", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (transitionPage('i00'))),
                          class: "panel_item"
                        }, _hoisted_32),
                        _createElementVNode("div", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (transitionPage('j00'))),
                          class: "panel_item"
                        }, _hoisted_35)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (transitionPage('n10'))),
                    class: "panel_item"
                  }, [
                    _hoisted_37,
                    (!_unref(menu).provisionFlg)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "未同意"))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_39,
                  _createElementVNode("div", {
                    onClick: logout,
                    class: "panel_logout"
                  }, _hoisted_42)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})